function Identify(user) {
  if (window.mixpanel) {
    window.mixpanel.identify(`${user.name} ${user.surname}`);
    window.mixpanel.people.set({
      name: `${user.name} ${user.surname}`,
      '$lastHomeVisit': new Date(),
    });
  }
}

function Track(event, params = {}) {
  if (window.mixpanel) {
    window.mixpanel.track(event, params);
  }
}

export default {
  Identify,
  Track,
};


